export const FEATURE = 'Feature';

export enum FeatureMotion {
  None,
  Move,
  Zoom,
  Default
}
